export default class FeaturedSteps {
    constructor(element) {
        this.passedElement = element;
        this.searchQuery = "";
        this.elementOffsetTop = element.offsetTop;
        this.wh = document.documentElement.clientHeight;
        this.passedElementHeight = element.offsetHeight;
        this.scrolled = window.scrollY;
        this.stepsContainer = element.querySelector('.rf-steps');
        this.steps = element.querySelectorAll('.rf-step');
        this.explainerContainer = element.querySelector('.rf-explainer-animation');
        this.stepVideo = this.explainerContainer.querySelector('video');
        this.stepVideos = [this.explainerContainer.getAttribute('data-video-1'),
                                this.explainerContainer.getAttribute('data-video-2'), 
                                this.explainerContainer.getAttribute('data-video-3')];
        this.previousActive;
        this.scaler = 1.5;
        this.init();
    }

    init = () => {
        if (!this.initialised) {
            this.initialised = true;
            this.getElements();
            this.addEventListeners();
        }
    }

    setActiveClass = (active) => {
        this.steps.forEach((step, i) => {
            step.classList.remove('prev', 'active', 'next');
        });
        if ( this.previousActive != active ) {
            this.previousActive = active;
            this.stepVideo.setAttribute('src',  this.stepVideos[active]);
        }
        this.steps[active-1]?.classList.add('prev');
        this.steps[active]?.classList.add('active');
        this.steps[active+1]?.classList.add('next');
    }

    setActiveIndex = () => {
        const activeIndex = Math.floor((this.scrolled - this.elementOffsetTop + (this.wh/2))/(this.wh*this.scaler));
        if ( activeIndex < this.steps.length ) {
            this.setActiveClass(activeIndex);
        }
    }

    handleWindowResize = () => {
        this.elementOffsetTop = this.passedElement.offsetTop;
        this.wh = document.documentElement.clientHeight;
        this.passedElementHeight = this.passedElement.offsetHeight;
        this.setActiveIndex();
    }

    handleWindowScroll = () => {
        this.scrolled = window.scrollY;
        this.setActiveIndex();
    }

    getElements = () => {
        this.setActiveIndex();
    }

    addEventListeners = () => {
        window.addEventListener('resize', this.handleWindowResize);
        window.addEventListener('scroll', this.handleWindowScroll);
    }

}